/**
 * odpowiednik Firmlet.changed
 * @param {HTMLInputElement} element
 */
export function valueChangedFromDefault(element) {
  return element.defaultValue !== element.value
}

/**
 * odpowiednik isEmptyObject z jQuery
 * to niestety działa i dla obiektów i dla stringów i tak było używane
 * @param {any} object
 * @returns {boolean}
 */
export function isEmpty(object) {
  // eslint-disable-next-line no-unreachable-loop
  for (const x in object) {
    return false
  }
  return true
}

/**
 * odpowiednik Firmlet.force_set_val_on_select
 * ustawia wartość danego selecta na value
 * tworzy brakujące option jeśli go nie ma
 * @param {HTMLSelectElement} select
 * @param {string} value
 * @returns {void}
 */
export function forceSetValueOnSelect(select, value) {
  if (!select.matches("select")) {
    // pewnie to input a nie select
    select.value = value
    return
  }

  const stringValue = String(value)
  for (const option of select.options) {
    if (option.value === stringValue) {
      select.value = stringValue
      return
    }
  }
  const newOption = document.createElement("option")
  newOption.value = newOption.innerText = stringValue
  select.append(newOption)
  select.value = stringValue
}

/**
 * odpowiednik Firmlet.escape_html
 * @param {string} s
 * @returns {string} s jako poprawny bezpieczny HTML
 */
export function escapeHtml(s) {
  const elem = document.createElement("div")
  elem.innerText = s
  return elem.innerHTML
}

/**
 * @param {Date} date
 * @returns {string}
 */
export function isoDateToString(date) {
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear().toString()
  return `${year}-${month}-${day}`
}

/**
 * Datepicker pokazuje datę w formacie locale'u interfejsu (dd.mm.yyyy, dd/mm/yyyy, dd-mm-yyyy),
 * a parametry z serwera i porównania leksykograficzne wymagają ISO. Wartość już ISO zostaje bez zmian.
 * @param {string} value
 * @returns {string}
 */
export function localDateToIso(value) {
  const match = /^(\d{2})[./-](\d{2})[./-](\d{4})$/.exec(value)
  return match ? `${match[3]}-${match[2]}-${match[1]}` : value
}

export function formatPriceSetup(locale) {
  let formattedExample = Intl.NumberFormat(locale).format("11111.1")
  formattedExample = formattedExample.trim()
  const thousandSeparator = formattedExample.length > 7 ? formattedExample.charAt(2) : ""
  const decimalSeparator = formattedExample.charAt(formattedExample.length - 2)

  return { thousandSeparator, decimalSeparator }
}

export function formatNumber(value, options) {
  const opts = formatPriceSetup(options.locale)
  let formattedValue = new Intl.NumberFormat(options.locale, {
    style: "decimal",
    minimumFractionDigits: options.app_digits,
    maximumFractionDigits: options.app_digits,
    useGrouping: "always"
  }).format(value).replace(/\s+/g, " ")
  formattedValue = formattedValue.replaceAll(opts.thousandSeparator, " ")
  return formattedValue
}

export function parseNumber(value, options) {
  if (value.length > 0) {
    value = value.replace(/[\s\u00A0]+/g, "")
    const opts = formatPriceSetup(options.locale)
    if (opts.thousandSeparator === "," && value.indexOf(".") === -1) {
      value = value.replaceAll(opts.thousandSeparator, ".")
    }
    const normalized = value.replace(opts.decimalSeparator, ".")
    return parseFloat(normalized)
  } else {
    return Number(0)
  }
}

/**
 * tworzy powiadomienie we frontendzie tailwind_mobile
 * odpowiednik growl w bootstrapie
 * @param {string} message
 * @param {boolean} withReplace
 * @param {Array} replaceFrom
 * @param {Array} replaceTo
 */
export function showNotification(message, withReplace = false, replaceFrom = [], replaceTo = []) {
  // let msg = this.translationsValue[message]
  if (withReplace) {
    replaceFrom.forEach((el, index) => {
      if (index in replaceTo) {
        message = message.replace(el, replaceTo[index])
      }
    })
  }
  window.dispatchEvent(new CustomEvent("update-message", { detail: { message } }))
}

export async function saveFile(name, url = null, blob = null) {
  if (isTurboNativeApp()) {
    const fileData = {
      type: "url",
      filename: name,
      mime: "application/octet-stream",
      url: null,
      base64: null
    }

    if (url) {
      fileData.url = url
    } else if (blob) {
      const base64String = await blobToBase64(blob)
      fileData.base64 = base64String
      fileData.mime = blob.type
      fileData.type = "file"
    } else {
      throw new Error("saveFile requires blob or url")
    }

    window.TurboNativeBridge.postMessage("downloadFile", fileData)
  } else {
    if (blob) url = window.URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = name
    document.body.appendChild(a)
    a.click()
    a.remove()
  }
}

async function blobToBase64(blob) {
  const arrayBuffer = await blob.arrayBuffer()
  return Buffer.from(arrayBuffer).toString("base64")
}

/**
 * wrapper na ustawianie wartości elementom podobnie do jquery
 * czyli bez rzucania błędem jeśli nie zostanie znaleziony (bo np nie ma go w formatce)
 * @param {string} selector
 * @param {string} value
 */
export function trySetValue(selector, value) {
  const element = document.querySelector(selector)
  if (element !== null) {
    element.value = value
  }
}

/**
 * Dodaje miesiąc w ten sam sposób jak railsowy 1.month.since (1.month.since(Date.parse('2025-01-31')) -> 2025-02-28)
 * @param {Date} date The starting Date object.
 * @param {number} months The number of months to add (e.g., 1).
 * @returns {Date} A new Date object with the months added.
 */
export function addMonthsRailsStyle(date, months) {
  const newDate = new Date(date.getTime())
  const originalDay = newDate.getDate()
  newDate.setMonth(newDate.getMonth() + months)
  if (newDate.getDate() < originalDay) {
    newDate.setDate(0)
  }
  return newDate
}

export function isTurboNativeApp() {
  return navigator.userAgent.includes("Turbo Native")
}

export function setValueAndDispatch(el, value) {
  if (!el) return

  el.value = value

  el.dispatchEvent(new Event("input", { bubbles: true }))
  el.dispatchEvent(new Event("change", { bubbles: true }))
}

/**
 * @param {object} rawProduct
 * @param {boolean} income
 * @returns {object}
 */
export function resolveProductPrices(rawProduct, income) {
  if (income) return rawProduct

  return { ...rawProduct, price_net: rawProduct.purchase_price_net, price_gross: rawProduct.purchase_price_gross, tax: rawProduct.purchase_tax }
}
